import type { HistoricalSource } from './sources';

export const CHURCH_SOURCES = {
  oldChurch: {
    url: 'https://www.oudekerk.nl/en/about-the-oude-kerk',
    title: 'About the Oude Kerk',
    publisher: 'Oude Kerk Amsterdam',
    note: {
      en: 'The church was consecrated to Saint Nicholas, patron saint of sailors, in 1306. Its building history spans several centuries. This reconstruction shows its earlier tower, before the later enlargement.',
      nl: 'De kerk werd in 1306 gewijd aan Sint Nicolaas, de beschermheilige van zeelieden. De bouwgeschiedenis beslaat meerdere eeuwen. Deze reconstructie toont de eerdere toren, vóór de latere verhoging.',
    },
  },
  newChurch: {
    url: 'https://www.nieuwekerk.nl/en/history/',
    title: 'History of De Nieuwe Kerk',
    publisher: 'De Nieuwe Kerk',
    note: {
      en: 'The growing population needed another parish church. The bishop approved the Nieuwe Kerk in 1408. Its present interior includes much later work; the reconstruction keeps the medieval building.',
      nl: 'De groeiende bevolking had een tweede parochiekerk nodig. De bisschop gaf in 1408 toestemming voor de Nieuwe Kerk. Het huidige interieur bevat veel later werk; de reconstructie toont het middeleeuwse gebouw.',
    },
  },
  olof: {
    url: 'https://www.amsterdam.nl/nieuws/achtergrond/sint-olofskapel/',
    title: 'Sint Olofskapel: 6 eeuwen Amsterdams lief en leed',
    publisher: 'Gemeente Amsterdam',
    note: {
      en: 'The medieval Sint-Olofskapel stood beside the old city gate. Pilgrims also visited the neighbouring Jerusalem chapel. The chapel seen today was rebuilt in the seventeenth century, after our 1538 setting.',
      nl: 'De middeleeuwse Sint-Olofskapel stond naast de oude stadspoort. Pelgrims bezochten ook de aangrenzende Jeruzalemkapel. De kapel die er nu staat werd herbouwd in de zeventiende eeuw, na onze stad uit 1538.',
    },
  },
  beguines: {
    url: 'https://www.amsterdam.nl/nieuws/achtergrond/begijnhof/',
    title: 'Wat weet u van het Begijnhof, het beroemdste hofje van de stad?',
    publisher: 'Gemeente Amsterdam',
    note: {
      en: 'Beguines were Catholic women who kept their own possessions and helped with care and education. Their medieval court was surrounded by water. The church became an English church in 1607; the later hidden Catholic chapel dates from 1671.',
      nl: 'Begijnen waren katholieke vrouwen die hun eigen bezit behielden en hielpen bij zorg en onderwijs. Hun middeleeuwse hof was omringd door water. De kerk werd in 1607 een Engelse kerk; de latere katholieke schuilkapel dateert uit 1671.',
    },
  },
  miracle: {
    url: 'https://www.amsterdam.nl/stadsarchief/canon/venster/4/',
    title: '1345 Mirakel van Amsterdam',
    publisher: 'Stadsarchief Amsterdam',
    note: {
      en: 'According to the 1345 miracle story, a consecrated wafer survived a fire. A chapel was built at the Heilige Stede, and pilgrims arrived along the Heiligeweg. Their belief helped make Amsterdam a pilgrimage town.',
      nl: 'Volgens het mirakelverhaal uit 1345 bleef een gewijde hostie intact in het vuur. Op de Heilige Stede werd een kapel gebouwd en pelgrims kwamen over de Heiligeweg. Hun geloof hielp Amsterdam uit te groeien tot een bedevaartstad.',
    },
  },
  agnieten: {
    url: 'https://www.amsterdam.nl/nieuws/achtergrond/wandeling-wallen/',
    title: 'Een zinderende wandeling over de Wallen',
    publisher: 'Gemeente Amsterdam',
    note: {
      en: 'The Agnietenkapel dates from 1470 and belonged to a convent. Its later use for learning belongs to the seventeenth century. In the 1538 city we show the chapel in its religious setting.',
      nl: 'De Agnietenkapel dateert uit 1470 en hoorde bij een klooster. Het latere gebruik voor onderwijs hoort bij de zeventiende eeuw. In de stad van 1538 tonen we de kapel in haar religieuze omgeving.',
    },
  },
  paulus: {
    url: 'https://dewaalsekerk.nl/over-ons/geschiedenis',
    title: 'Geschiedenis van De Waalse Kerk',
    publisher: 'De Waalse Kerk',
    note: {
      en: 'The Paulusbroeders received permission to build a chapel in 1493; it was consecrated in 1496. Only after the Alteration of 1578 did it become a church for French-speaking Protestants. The 1538 tour uses its earlier convent identity.',
      nl: 'De Paulusbroeders kregen in 1493 toestemming voor een kapel; deze werd in 1496 gewijd. Pas na de Alteratie van 1578 werd zij een kerk voor Franstalige protestanten. De rondleiding gebruikt de vroegere kloosternaam uit 1538.',
    },
  },
} as const satisfies Readonly<Record<string, HistoricalSource>>;
